export default __webpack_public_path__ + "static/media/higher_primary_logo_url.e218e8ae.svg";